export default __webpack_public_path__ + "static/media/zhulou.7d17b4bc.png";